<style>
.checkbox > label {
    font-size: 14px;
}

/*.v-data-footer {*/
/*    max-width: 960px;*/
/*    text-align: center;*/
/*}*/
</style>
<template>
    <v-container fluid class="pt-3" id="eshop--view">
        <v-row class="secondary" v-if="items.length > 0">
                <v-col class="caption" cols="12" sm="4" xs="12">{{ $t('Filtr pro kategorie') }}
                    <v-chip-group v-model="categories" column multiple>
                        <v-chip filter color="primary" v-for="category in allCategories" :key="category.categoryName"
                                :value="category.categoryName">{{ category.categoryName }}
                        </v-chip>
                    </v-chip-group>
                </v-col>
                <v-col class="caption" cols="12" sm="4" xs="12">{{ $t('Filtr pro dostupnost') }}
                    <v-chip-group v-model="availability" column>
                        <v-chip filter color="primary" value="virtual">{{ $t('Elektronické') }}</v-chip>
                        <v-chip filter color="primary" value="available">{{ $t('Skladem') }}</v-chip>
                    </v-chip-group>
                </v-col>
                <v-col cols="12" sm="4" xs="12">
                    <v-text-field class="mt-2" solo flat persistent-hint :hint="$t('Hledej')" append-icon="search" label="Hledej"
                                  single-line
                                  hide-details v-model="search"></v-text-field>
                </v-col>
        </v-row>
        <v-container fluid class="px-0 py-0">
            <v-data-iterator :search="search" :custom-filter="customFilter" class="elevation-0" :items="items"
                             items-per-page.sync="2"
                             xs-items-per-page="2"
                             sm-items-per-page="4"
                             md-items-per-page="6"
                             lg-items-per-page="8"
                             xl-items-per-page="12"
                             :footer-props="{ itemsPerPageOptions }"
                             :no-data-text="$t('Obchod je prázdný')"
                             :no-results-text="$t('Nejsou dostupné žádné produkty')"
                             v-if="items.length > 0">
                <template v-slot:loading>
                    <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                </template>
                <template v-slot:default="props">
                    <v-row>
                        <v-col xs="12" sm="6" md="4" lg="3" xl="2" cols="12" v-for="item in props.items" :key="item.name">
                            <v-hover close-delay="50" v-slot:default="{ hover }">
                                <v-card outlined :height="370" :elevation="hover ? 10 : 1"
                                        :color="hover ? 'secondary' : 'white'">
                                    <v-card-title>
                                        <v-row dense style="height: 60px;">
                                            <v-col cols="12" class="text-center">
                                                <!--                    <img :src="require('../assets/img/' + item.image.imageUrl)" v-if="item.image">-->
                                                <img :src="item.image.imageUrl" v-if="item.image">
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-row dense>
                                            <v-col cols="12" class="text-center" style="height: 25px;">
                                                <div class="font-weight-bold subtitle-2">{{ item.itemName }}</div>
                                            </v-col>
                                            <v-col cols="12" class="text-center" style="height: 25px;">
                                                <div class="font-weight-light caption" v-if="item.currentValidity">
                                                    {{ $t('Platnost do:') }}
                                                    {{ item.currentValidity | moment('D.M.Y HH:mm:ss') }}
                                                </div>
                                            </v-col>
                                            <v-col cols="6" class="text-center" style="height: 25px;">
                                                <div class="font-weight-light caption">
                                                    <div v-if="item.unit.unitValue">{{ $t('Balení po ') }}
                                                        {{ item.unit.unitValue }}
                                                        {{ item.unit.unitShortName }}
                                                    </div>
                                                </div>
                                            </v-col>
                                            <v-col cols="6" class="text-center" style="height: 30px;">
                                                <div class="font-weight-light caption">
                                                    <div class="color: green--text"
                                                         v-if="!item.isVirtual && item.itemCount > 0">{{
                                                        $t('Skladem ')
                                                        }} {{
                                                        item.itemCount > 10 ? item.itemCount : $t('více než 10')
                                                        }}
                                                        {{ ' ' + item.unit.unitShortName }}
                                                    </div>
                                                    <div class="color: red--text" v-else-if="!item.isVirtual">
                                                        {{ $t('Není skladem') }}
                                                    </div>
                                                    <div class="color: green--text" v-else>{{ 'Dostupné' }}</div>
                                                </div>
                                            </v-col>
                                            <v-col cols="12" class="text-center" style="height: 80px;">
                                                <div class="font-weight-light caption"
                                                     v-if="item.itemDesc.length < 200">{{
                                                    item.itemDesc
                                                    }}
                                                </div>
                                                <div v-else>
                                                    <v-tooltip top max-width="200px">
                                                        <template v-slot:activator="{ on }">
                                                            <div class="font-weight-light caption" v-on="on">{{
                                                                item.itemDesc.substring(0, 200)
                                                                }}{{ ' ...' }}
                                                            </div>
                                                        </template>
                                                        <span>{{ item.itemDesc }}</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row dense>
                                            <v-col cols="12" class="text-center">
                                                <div class="font-weight-bold">
                                                    {{ item.currentCustomerPrice | currency }}
                                                  <span class="font-weight-light" v-if="item.vatType">
                                                    {{ ' (' }}{{ item.vatType.vatRate / 100 }}{{ '% DPH)' }}
                                                  </span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-card-text>
                                    <!--              <v-col xs3 offset-xs1>-->
                                    <!--                  <v-text-field solo flat placeholder="1" min=1 max=100 :hint="$t('Počet')" v-model.number="item.volume" persistent-hint type="number" :readonly="basketItem(item).volume"></v-text-field>-->
                                    <!--                </v-col>-->
                                    <v-card-actions>
                                        <v-container fluid>
                                            <v-row dense v-if="hover">
                                                <v-row dense v-if="basketItem(item).volume">
                                                    <v-col cols="12" class="text-center">
                                                        <v-tooltip bottom>
                                                            <span>{{ $t('Snížit množství') }}</span>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn icon color="primary"
                                                                       @click.native.stop="decrementItem(basketItem(item))"
                                                                       v-on="on">
                                                                    <v-icon>mdi-minus-circle</v-icon>
                                                                </v-btn>
                                                            </template>
                                                        </v-tooltip>
                                                        <small>{{ basketItem(item).volume }} {{ $t('ks') }}</small>
                                                        <v-tooltip bottom>
                                                            <span>{{ $t('Zvýšit množství') }}</span>
                                                            <template v-slot:activator="{ on }">
                                                                <v-btn icon color="primary"
                                                                       @click.native.stop="incrementItem(basketItem(item))"
                                                                       v-on="on">
                                                                    <v-icon>mdi-plus-circle</v-icon>
                                                                </v-btn>
                                                            </template>
                                                        </v-tooltip>
                                                    </v-col>
                                                    <v-col cols="12" class="text-center">
                                                        <div v-if="creditCardId">
                                                            <v-tooltip top v-if="validCard(creditCardId)">
                                                                <span>{{
                                                                    validCard(creditCardId).mainRate ? validCard(creditCardId).mainRate.name : ''
                                                                    }}</span>
                                                                <br>
                                                                <span>{{
                                                                    $t('Karta:')
                                                                    }} {{ displayedCardNo(creditCardId) }}</span>
                                                                <br>
                                                                <span>{{
                                                                    $t('Kredit:')
                                                                    }} {{
                                                                    validCard(creditCardId).customerDisplayedCredit | currency
                                                                    }}</span>
                                                                <template v-slot:activator="{ on }">
                                                                    <a class="font-weight-light caption red--text"
                                                                       @click.stop="resetTypeOfPayment(item)" v-on="on">{{
                                                                        $t('Produkt bude uhrazen kreditem')
                                                                        }}</a>
                                                                </template>
                                                            </v-tooltip>
                                                        </div>
                                                        <a class="font-weight-light caption green--text"
                                                           @click.stop="setTypeOfPayment(item)"
                                                           v-else-if="hasValidCards && !dialogPayment && item.canUseCredit == true">{{
                                                            $t('Produkt lze hradit kreditem')
                                                            }}</a>
                                                        <div v-else-if="dialogPayment">
                                                            <v-tooltip top v-for="card in validCards"
                                                                       :key="card.cardId">
                                                                <span>{{
                                                                    card.mainRate ? card.mainRate.name : ''
                                                                    }}</span>
                                                                <br>
                                                                <span>{{ $t('Karta:') }} {{
                                                                    card.displayedCardNo
                                                                    }}</span>
                                                                <br>
                                                                <span>{{
                                                                    $t('Kredit:')
                                                                    }} {{
                                                                    card.customerDisplayedCredit | currency
                                                                    }}</span>
                                                                <template v-slot:activator="{ on }">
                                                                    <a class="font-weight-light caption primary--text"
                                                                       @click.stop="setTypeOfPayment(item, card.cardId)"
                                                                       v-on="on">{{ card.displayedCardNo }}{{ ' ' }}</a>
                                                                </template>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                                <v-row dense v-else>
                                                    <v-col cols="12" class="text-center">
                                                        <v-btn color="primary" @click="addItem(item, creditCardId)">
                                                            {{ $t('Do košíku') }}
                                                            <v-icon right>add_shopping_cart</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" class="text-center">
                                                        <div v-if="creditCardId">
                                                            <v-tooltip top v-if="validCard(creditCardId)">
                                                                <span>{{
                                                                    validCard(creditCardId).mainRate ? validCard(creditCardId).mainRate.name : ''
                                                                    }}</span>
                                                                <br>
                                                                <span>{{
                                                                    $t('Karta:')
                                                                    }} {{ displayedCardNo(creditCardId) }}</span>
                                                                <br>
                                                                <span>{{
                                                                    $t('Kredit:')
                                                                    }} {{
                                                                    validCard(creditCardId).customerDisplayedCredit | currency
                                                                    }}</span>
                                                                <template v-slot:activator="{ on }">
                                                                    <a class="font-weight-light caption red--text"
                                                                       @click.stop="resetTypeOfPayment(item)" v-on="on">{{
                                                                        $t('Produkt bude uhrazen kreditem')
                                                                        }}</a>
                                                                </template>
                                                            </v-tooltip>
                                                        </div>
                                                        <a class="font-weight-light caption green--text"
                                                           @click.stop="setTypeOfPayment(item)"
                                                           v-else-if="hasValidCards && !dialogPayment && item.canUseCredit == true">{{
                                                            $t('Produkt lze hradit kreditem')
                                                            }}</a>
                                                        <div v-else-if="dialogPayment">
                                                            <v-tooltip top v-for="card in validCards"
                                                                       :key="card.cardId">
                                                                <span>{{
                                                                    card.mainRate ? card.mainRate.name : ''
                                                                    }}</span>
                                                                <br>
                                                                <span>{{ $t('Karta:') }} {{
                                                                    card.displayedCardNo
                                                                    }}</span>
                                                                <br>
                                                                <span>{{
                                                                    $t('Kredit:')
                                                                    }} {{
                                                                    card.customerDisplayedCredit | currency
                                                                    }}</span>
                                                                <template v-slot:activator="{ on }">
                                                                    <a class="font-weight-light caption primary--text"
                                                                       @click.stop="setTypeOfPayment(item, card.cardId)"
                                                                       v-on="on">{{ card.displayedCardNo }}{{ ' ' }}</a>
                                                                </template>
                                                            </v-tooltip>
                                                        </div>
                                                    </v-col>
                                                </v-row>
                                            </v-row>
                                            <v-row v-else-if="basketItem(item).volume">
                                                <v-col cols="12" class="text-center">
                                                    <small>{{ $t('V košíku') }} {{ basketItem(item).volume }}
                                                        {{ $t('ks') }}</small>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-actions>

                                    <!-- <v-menu max-width="960" max-height="600" v-model="toBasket" :close-on-content-click="false" :open-on-hover="validCards.length > 0" top>
                                          <template v-slot:activator="{ on }">
                                            <v-btn color="primary" @click.native="toBasket = false" @click="addItem(item)" v-on="on">{{ $t('Do košíku') }}
                                              <v-icon right>add_shopping_cart</v-icon>
                                            </v-btn>
                                          </template>
                                          <v-list light dense>
                                            <v-list-item @click="addItem(item)">
                                              <v-list-item-content>{{ $t('Uhradit hotově') }}</v-list-item-content>
                                            </v-list-item>
                                            <v-list-item filter color="primary" v-for="card in validCards" :key="card.cardId" @click="addItem(item, card.cardId)">{{ $t('Uhradit kartou č. ')}} {{ card.displayedCardNo }}</v-list-item>
                                          </v-list>
                                        </v-menu> -->
                                    <!-- <v-col cols="12" class="text-center">
                                        <small class="font-weight-light class="caption" color: red--text" v-if="item.canUseCredit && creditCardId">{{ $t('Hrazeno kreditem') }}</small>
                                        <small class="font-weight-light class="caption" color: green--text" v-else>{{ $t('Hrazeno hotovostí') }}</small>
                                      </v-col> -->
                                </v-card>
                            </v-hover>
                            <!-- <v-divider></v-divider> -->
                        </v-col>
                    </v-row>
                </template>
            </v-data-iterator>
            <v-alert type="info" color="grey lighten-1" class="pt-6" v-else>
                {{ $t('Obchod je prázdný') }}
            </v-alert>
        </v-container>
<!--        <v-row class="background: grey lighten-1">-->
<!--            <v-container fluid class="px-0 py-0" style="max-width: 960px;">-->
<!--                <v-alert type="info" color="grey lighten-1">-->
<!--                    {{ $t('Zde můžete nakoupit naše produkty, vstupenky a dárkové poukazy') }}-->
<!--                </v-alert>-->
<!--            </v-container>-->
<!--        </v-row>-->
    </v-container>
</template>
<script>
import BasketMixin from '@/mixins/basket-mixin'
import CustomerMixin from '@/mixins/customer-mixin'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import StorageMixin from '@/mixins/storage-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
    name: 'EshopPage',
    mixins: [BasketMixin, CustomerMixin, InstitutionMixin, StorageMixin, TransformMixin],
    data() {
        return {
            search: null,
            creditCardId: undefined,
            items: [],
            categories: [],
            availability: null,
            timer: null,
            itemsPerPageOptions: [2, 6, 12],
            // itemsPerPage: 9,
            dialogPayment: false
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    mounted() {
        this.availability = this.$oauth2.storage.hasValue('chip-esh-ava') ? this.$oauth2.storage.getValue('chip-esh-ava') : null
        this.getItems()
    },
    computed: {
        allCategories: {
            get() {
                var cats = []
                this.items.forEach(i => {
                    i.categories.forEach(cat => {
                        if (!cats.map(c => c.categoryName).includes(cat.categoryName)) {
                            cats.push(cat)
                        }
                    })
                })
                return cats
            }
        }
    },
    methods: {
        hasAvailable(value) {
            return !this.availability || (this.availability === 'virtual' && value.isVirtual) || (this.availability === 'available' && (value.itemCount > 0 || value.isVirtual))
        },
        hasCategory(value) {
            return value.categories.some(ic => this.categories.includes(ic.categoryName))
        },
        getItems() {
            return this.$fetch('my/institutions/sellable-items').then(data => {
                this.items = data.map(i => i.item).sort((a, b) => {
                    const a1 = a.image.imageUrl.split('/').pop()
                    const b1 = b.image.imageUrl.split('/').pop()
                    if (a1 < b1) {
                        return -1
                    }
                    if (a1 > b1) {
                        return 1
                    }
                    return 0
                })
                if (!this.timer) {
                    const storaged = this.$oauth2.storage.hasValue('chip-esh-sel') ? this.$oauth2.storage.getValue('chip-esh-sel').split(',') : null
                    this.allCategories.forEach(c => {
                        if (!storaged || storaged.includes(c.categoryName)) {
                            this.categories.push(c.categoryName)
                        }
                    })
                }
                this.timer = setTimeout(() => this.getItems(), 300000)
            }).catch(() => console.log('eshop get error'))
        },

        customFilter(items, search) {
            return items.filter(i => this.hasAvailable(i)).filter(i => this.hasCategory(i))
                .filter(i => search === null || i.itemName.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')))
        },
        setTypeOfPayment(item, cardId = null) {
            console.log(item)
            if (cardId === null && this.validCards.length > 1) {
                this.dialogPayment = true
            } else {
                this.creditCardId = cardId ? cardId : this.validCards[0].cardId
                if (this.basketItem(item)) {
                    this.basketItem(item).creditCardId = this.creditCardId
                    this.refreshBasket()
                }
            }
        },
        resetTypeOfPayment(item) {
            this.creditCardId = null
            if (this.basketItem(item)) {
                this.basketItem(item).creditCardId = null
                this.refreshBasket()
            }
        }
    },
    watch: {
        categories(value) {
            if (value) {
                this.$oauth2.storage.setValue('chip-esh-sel', this.categories, this.institutionId, this.customerId)
            } else {
                this.$oauth2.storage.removeValue('chip-esh-sel', this.institutionId, this.customerId)
            }
        },
        availability(value) {
            if (value) {
                this.$oauth2.storage.setValue('chip-esh-ava', this.availability, this.institutionId, this.customerId)
            } else {
                this.$oauth2.storage.removeValue('chip-esh-ava', this.institutionId, this.customerId)
            }
        }
    }
}
</script>
